import React from 'react'
import Profilee from '../../Components/tutor/Profilee'
import BackgroundProps from './Background'

function Profile() {
  return (
    <div>
     <Profilee/>
      
    </div>
  )
}

export default Profile
